import { Routes, Route, useLocation } from "react-router-dom";
import React, { useState, useEffect, useRef, useContext } from 'react';
import { DynamicItem, Sidebar, dummyData } from "./components";
import { AnimatePresence } from "framer-motion";
import "./App.css";
import { motion } from "framer-motion";
import { ThemeContext } from "./ThemeContext";
import backgroundImg from "./assets/background.jpg";

function AnimatedRoutes() {
  const location = useLocation();
  const { mathMode } = useContext(ThemeContext);

  return (
    <div className="route-container">
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          initial={mathMode ? false : { opacity: 0 }}
          animate={mathMode ? false : { opacity: 1 }}
          exit={mathMode ? false : { opacity: 0 }}
          transition={mathMode ? { duration: 0 } : { duration: 0.4 }}
        >
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<DynamicItem page="about me" />} />

            {dummyData.map((item, index) => (
              <Route
                key={index}
                path={item.path}
                element={<DynamicItem page={item.name} />}
              />
            ))}
          </Routes>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}

function App() {
  const { transitioning } = useContext(ThemeContext);
  const { mathMode } = useContext(ThemeContext);

  React.useEffect(() => {
    if (mathMode) {
      document.body.style.backgroundColor = "#b8c6ca";
      // document.body.style.backgroundImage = `url(${backgroundImg})`;
      // document.body.style.backgroundRepeat = "repeat";
      // document.body.style.backgroundSize = "300px";
    } else {
      document.body.style.backgroundColor = "#ffffff";
      // document.body.style.backgroundImage = "none";
    }
  }, [mathMode]);

  return (
    <motion.div id="main" style={{
      minHeight: "100vh",
      transition: "background-color 0.4s ease",
    }}
    animate={{
      opacity: transitioning ? 0 : 1
    }}
    transition={{
      duration: 0.5
    }}>
      <Sidebar>
        <motion.div
          style={{ width: "100%" }}
          animate={{
            opacity: transitioning ? 0 : 1
          }}
          transition={{
            duration: 0.5
          }}
        >
          <AnimatedRoutes />
        </motion.div>
      </Sidebar>
    </motion.div>
  );
}
export default App;